import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { secondaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export interface HomepageBlock1Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  buttons?: ReactNode;
  content?: ReactNode;
  header?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock1 = forwardRef<HTMLDivElement, HomepageBlock1Props>(
  ({ header, buttons, content, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: secondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-secondary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-2xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                  {header}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3 md:wb-flex-row wb-justify-center wb-items-center">
                  {buttons}
                </BlockSection.NestedBlock>
              </div>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-10 md:wb-gap-11">
                {content}
              </BlockSection.NestedBlock>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock1.displayName = "HomepageBlock1";
